export default {
    namespaced: true,
    
    actions: {
        send({ commit }, { email, type, body }){
            return axios.post('/feedback', { email, type, body, name:'' })
        }
    },
}